import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

const useStyles = makeStyles((theme) => ({
  imgLegend: {
    padding: 8,
    width: theme.spacing(5),
    bottom: 60,
    position: 'absolute',
    right: 10,
    zIndex: 1000,
    borderRadius: 5,
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3)
  },
}))

function Legend({ layersState, layer, width }) {
  const classes = useStyles()

  return (
    <Paper className={classes.imgLegend}>
      <Grid container>
        {layer.legend
          ?.slice(0)
          .reverse()
          .map((l, index) => (
            <Grid key={index} item xs={12}>
              <Avatar
                variant="square"
                className={classes.small}
                style={{
                  backgroundColor: l.color,
                  fontSize: 10,
                  height: 200 / layer.legend?.slice(0).length,
                }}
              >
                {l.label}
              </Avatar>
            </Grid>
          ))}
      </Grid>
    </Paper>
  )
}

export default withWidth()(Legend);
